export default __webpack_public_path__ + "static/media/2-stepRes.b2e7b176.png";